import React from 'react';
import { StarIcon } from 'lucide-react';
const scrollToPricing = () => {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function HeroSection() {
  return <section className="w-full py-8 md:py-16 px-4 bg-[#FFFFFF]" data-id="element-207">
      <div className="max-w-3xl mx-auto text-center" data-id="element-208">
        {/* Title */}
        <h1 className="text-3xl md:text-5xl font-black font-heading text-gray-900 leading-tight mb-3" data-id="element-209">
          Regresa la calma a casa en tan solo{' '}
          <span className="text-red-600" data-id="element-210">7 días</span>
        </h1>

        <p className="text-lg md:text-xl text-gray-700 italic mb-6 font-body" data-id="element-211">
          Acompaña a tu hijo sin gritos, sin culpa y con un sistema claro
        </p>

        {/* Product Image */}
        <div className="my-8 cursor-pointer" onClick={scrollToPricing} data-id="element-212">
          <img src="https://cdn.magicpatterns.com/uploads/sPCnVPMtXioPTct6J7b21f/MOCKUP_600x.png" alt="MegaPack TDAH en Retroceso - 5 tomos completos" className="w-full max-w-2xl mx-auto drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300" width={665} height={426} fetchPriority="high" decoding="async" data-id="element-213" />
        </div>

        <p className="text-base md:text-lg text-gray-600 mb-8 max-w-2xl mx-auto font-body leading-relaxed" data-id="element-214">
          El sistema que ya están utilizando cientos de madres y padres para
          acompañar el comportamiento de sus hijos desde casa — sin improvisar,
          sin gritar y sin sentirse desbordados.
        </p>

        {/* Trust Badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8" data-id="element-215">
          <div className="bg-gray-50 rounded-lg p-3 text-center" data-id="element-216">
            <span className="text-2xl" data-id="element-217">📄</span>
            <p className="text-xs font-semibold text-gray-700 mt-1" data-id="element-218">
              100% digital (PDF)
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-3 text-center" data-id="element-219">
            <span className="text-2xl" data-id="element-220">⚡</span>
            <p className="text-xs font-semibold text-gray-700 mt-1" data-id="element-221">
              Acceso inmediato
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-3 text-center" data-id="element-222">
            <span className="text-2xl" data-id="element-223">🌍</span>
            <p className="text-xs font-semibold text-gray-700 mt-1" data-id="element-224">
              Funciona en cualquier país hispanohablante
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-3 text-center" data-id="element-225">
            <span className="text-2xl" data-id="element-226">👨‍👩‍👧‍👦</span>
            <p className="text-xs font-semibold text-gray-700 mt-1" data-id="element-227">
              Para niños de 4 a 10 años
            </p>
          </div>
        </div>

        {/* CTA Button */}
        <button onClick={scrollToPricing} className="w-full md:w-auto bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black md:text-2xl px-10 py-5 rounded-xl shadow-lg animate-pulse-glow transition-colors duration-200 cursor-pointer font-heading text-[16px]" data-id="element-228">
          👉 ADQUIRIR MEGAPACK AHORA
        </button>

        {/* Security Badges */}
        <div className="flex flex-wrap justify-center gap-4 mt-6 text-sm text-gray-500" data-id="element-229">
          <span data-id="element-230">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-231">🔒 Pago 100% seguro</span>
          <span data-id="element-232">💳 Pagas en la moneda de tu país</span>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10 border-t border-b border-gray-200 py-6" data-id="element-233">
          <div className="text-center" data-id="element-234">
            <p className="text-2xl md:text-3xl font-black font-heading text-gray-900" data-id="element-235">
              +1.500
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-236">familias acompañadas</p>
          </div>
          <div className="text-center" data-id="element-237">
            <p className="text-2xl md:text-3xl font-black font-heading text-gray-900" data-id="element-238">
              5
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-239">tomos completos</p>
          </div>
          <div className="text-center" data-id="element-240">
            <p className="text-2xl md:text-3xl font-black font-heading text-gray-900" data-id="element-241">
              4.8/5
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-242">calificación ⭐</p>
          </div>
          <div className="text-center" data-id="element-243">
            <p className="text-2xl md:text-3xl font-black font-heading text-gray-900" data-id="element-244">
              🌍
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-245">
              Todo el mundo hispanohablante
            </p>
          </div>
        </div>

        {/* Initial Testimonials */}
        <div className="mt-10 space-y-4" data-id="element-246">
          <div className="bg-gray-50 rounded-xl p-5 text-left" data-id="element-247">
            <div className="flex gap-0.5 mb-2" data-id="element-248">
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-249" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-250" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-251" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-252" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-253" />
            </div>
            <p className="text-gray-800 italic font-body" data-id="element-254">
              "Mi casa volvió a la calma en menos de una semana"
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-255">
              — Mariana G. | Mamá de niño de 6 años
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 text-left" data-id="element-256">
            <div className="flex gap-0.5 mb-2" data-id="element-257">
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-258" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-259" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-260" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-261" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-262" />
            </div>
            <p className="text-gray-800 italic font-body" data-id="element-263">
              "Dejé de gritar… y mi hijo empezó a escuchar"
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-264">
              — Laura P. | Mamá de niño de 8 años
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 text-left" data-id="element-265">
            <div className="flex gap-0.5 mb-2" data-id="element-266">
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-267" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-268" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-269" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-270" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-271" />
            </div>
            <p className="text-gray-800 italic font-body" data-id="element-272">
              "Ahora entiendo lo que le pasa y sé qué hacer"
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-273">
              — Rodrigo M. | Papá
            </p>
          </div>
        </div>
      </div>
    </section>;
}